import { useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

// "Notify me when it's back": saves the email to Shopify customers with a restock tag.
// Marketing emails only if the box is ticked (unticked by default).
export default function RestockForm({ handle, size }) {
  const [email, setEmail] = useState("");
  const [marketing, setMarketing] = useState(false);
  const [website, setWebsite] = useState(""); // hidden from people; bots fill it
  const [state, setState] = useState("idle"); // idle | sending | done | error
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("sending");
    setMessage("");
    try {
      await api.post("/restock", { email: email.trim(), handle, size: size || null, marketing, website });
      setState("done");
    } catch (err) {
      const status = err.response?.status;
      setMessage(
        status === 400 ? "Enter a valid email address."
          : status === 429 ? "Too many tries. Try again in a few minutes."
          : "Couldn't save that. Try again in a minute."
      );
      setState("error");
    }
  };

  if (state === "done") {
    return (
      <p data-testid="restock-done" className="mt-4 text-sm text-[#D9D7D2]">
        You're on the list. We'll email you if {size ? `size ${size}` : "it"} comes back.
      </p>
    );
  }

  return (
    <form data-testid="restock-form" onSubmit={submit} className="ph-no-capture mt-4 border border-[#8A8A8A]/20 p-4">
      <p className="text-[10px] uppercase tracking-[0.2em] text-[#F2F0EB]">Notify me when it's back</p>
      <p className="mt-2 text-xs text-[#8A8A8A]">Leave your email and we'll let you know if {size ? `size ${size}` : "it"} comes back.</p>
      <div className="mt-3 flex gap-2">
        <label htmlFor="restock-email" className="sr-only">Email</label>
        <input
          id="restock-email"
          data-testid="restock-email"
          type="email"
          required
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email address"
          className="flex-1 min-w-0 bg-transparent border border-[#8A8A8A]/30 px-3 py-3 text-sm text-[#F2F0EB] outline-none focus:border-[#F2F0EB] placeholder:text-[#8A8A8A]/60"
        />
        <button data-testid="restock-submit" type="submit" disabled={state === "sending"} className="bg-[#F2F0EB] text-[#0A0A0A] px-4 font-['Oswald'] text-[11px] uppercase tracking-[0.2em] font-semibold hover:bg-[#8A8A8A] transition-colors disabled:opacity-50 flex items-center gap-2">
          {state === "sending" && <Loader2 size={12} className="animate-spin" />} Notify me
        </button>
      </div>
      <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" value={website} onChange={(e) => setWebsite(e.target.value)} className="hidden" />
      <label className="mt-3 flex items-start gap-2 text-xs text-[#8A8A8A] cursor-pointer">
        <input data-testid="restock-marketing" type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="mt-0.5 accent-[#F2F0EB]" />
        <span>Also send me AERWEAR news and new drops.</span>
      </label>
      {message && <p data-testid="restock-error" className="mt-2 text-xs text-[#F2F0EB]">{message}</p>}
    </form>
  );
}
